export function mainPads () {
    let headerHeight = $('.navbar-brand img').height() + 56;
    let documentWidth = $(window).innerWidth();

    $('#home-slider, #header + #sideBarWrapper, #hero').css('margin-top', headerHeight);

    if(documentWidth < 992) {
      $('#main-nav-bar').css('height' , $(window).height() - headerHeight );
    } else {
      $('#main-nav-bar').removeAttr('style');
    }
}




// WEBPACK FOOTER //
// ./scripts/includes/main-top-padding.js